<template>
  <div class="dealer-car__blog-article container section-car-padding" v-if="pageLoaded">
      <div class="head">
          <h2 class="title-h2">Reynsluakstur</h2>
      </div>
      <div class="body">
          <div class="dealer-car__blog-article-video">
              <img :src="imageURL" alt="">
          </div>
          <div class="dealer-car__blog-article-content">
              <h3 class="dealer-car__blog-article-title">{{title}}</h3>
              <p class="dealer-car__blog-article-description">{{description}}</p>
              
              <div class="dealer-car__blog-article-buttons">
                  <ButtonLink :href="pageURL" :routerLink="true">
                      Horfa á reynsluakstur
                  </ButtonLink>

                  <ABlank :href="'#'" class="btn btn-dealer">
                    <img src="/img/arrow.svg" />
                    Lesa meira
                  </ABlank>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import ABlank from "@/components/ABlank.vue"
import ButtonLink from "@/components/Dealers/share/ButtonLink"
import axios from "axios"
// import {API_URL} from "@/core/api"
import BASE_URL from '@/helpers/getBaseUrl'

import { blog, testdrive } from "@/staticData/routesName/blog"
export default {
    components: {
        ABlank,
        ButtonLink
    },
    props: {
        propCarID: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        blogID: '',
        imageURL: '',
        title: '',
        description: '',
        pageLoaded: false
    }),
    mounted() {
        axios.get(`${BASE_URL()}/api/blog?car_id=${this.propCarID}`)
            .then(res => {
                const data = res && res.data[0];
                if(!data) {
                    console.log('Blog article is empty!')
                    return
                }
                this.blogID = data.id;
                this.imageURL = data.img.file_name;
                this.title = data.title;
                this.description = data.description;
                this.pageLoaded = true
            })
    },
    computed: {
        pageURL() {
            return `${blog}${testdrive}/${this.blogID}`
        }
    }
}
</script>